import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import { Wrapper } from '../styles';

export const Vendor = styled.td`
  position: relative;
  padding: 0;
  text-align: center;
  width: 100%;
  display: inline;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 1.5rem;
    width: auto;
    display: table-cell;
  }

  ${Wrapper}.row-layout-chart & {
    text-align: center;
    padding: 1.5rem 0;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      text-align: left;
    }
  }
`;

export const VendorHead = styled.th`
  &:first-child {
    display: block;
    width: 100%;
    text-align: center;
    padding: 0;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      display: table-cell;
      vertical-align: middle;
      width: ${props => `calc(100% / ${props.columnCount})`};
      text-align: left;
    }

    * {
      clip: rect(0 0 0 0);
      clip-path: inset(50%);
      height: 1px;
      overflow: hidden;
      position: absolute;
      white-space: nowrap;
      width: 1px;
    }
  }
`;

export const Heading = styled.div`
  ${Wrapper}.two-column & {
    &:last-child {
      p {
        font-size: 1.25rem;
        line-height: 1.25rem;

        @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
          font-size: 1.5rem;
          line-height: 2rem;
        }

        sup {
          ${({ lang }) =>
            lang === 'fr'
              ? css`
                  font-size: 0.3rem;
                  top: -0.4rem;

                  @media only screen and (min-width: 340px) {
                    font-size: 0.4rem;
                  }

                  @media only screen and (min-width: ${themeGet(
                      'breakpoints.sm',
                    )}) {
                    font-size: 0.5rem;
                  }

                  @media only screen and (min-width: ${themeGet(
                      'breakpoints.md',
                    )}) {
                    top: -0.5rem;
                  }

                  @media only screen and (min-width: ${themeGet(
                      'breakpoints.xlg',
                    )}) {
                    top: -0.8rem;
                  }
                `
              : null}
        }
      }
    }
  }
`;
